import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import PasswordForm from '../../components/profile/PasswordForm';
import BankDetailsForm from '../../components/profile/BankDetailsForm';
import DeleteAccount from '../../components/profile/DeleteAccount';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useProfile } from '../../hooks/useProfile';
import { sellerService } from '../../services/seller.service';
import { useToast } from '../../components/common/Toast';
import { theme } from '../../config/theme';

const SellerSettings = () => {
  const { changePassword, loading: passwordLoading } = useProfile();
  const toast = useToast();
  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bankLoading, setBankLoading] = useState(false);

  useEffect(() => {
    fetchSellerProfile();
  }, []);

  const fetchSellerProfile = async () => {
    try {
      const response = await sellerService.getProfile();
      setSeller(response.data.seller);
    } catch (error) {
      toast.error('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const handleBankSubmit = async (data) => {
    setBankLoading(true);
    try {
      await sellerService.updateProfile(data);
      toast.success('Bank details updated');
      fetchSellerProfile();
    } catch (error) {
      toast.error('Failed to update bank details');
    } finally {
      setBankLoading(false);
    }
  };

  if (loading) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Settings
        </h1>

        <div style={{ marginBottom: theme.spacing.xl }}>
          <PasswordForm onSubmit={changePassword} loading={passwordLoading} />
        </div>

        <div style={{ marginBottom: theme.spacing.xl }}>
          <BankDetailsForm seller={seller} onSubmit={handleBankSubmit} loading={bankLoading} />
        </div>

        <DeleteAccount />
      </div>
    </MainLayout>
  );
};

export default SellerSettings;